export const deleteContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "Please confirm if you would like to Delete the specific market?" }
];

export const bulkDeleteContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "Please confirm if you would like to Delete the selected markets?" }
]

export const deleteDashboardContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "Please confirm if you would like to Delete the specific dashboard?" }
];

export const addtoLibrary = [
    { modalHeading: "Confirm Add to Dashboard" },
    { modalContent: "Are you sure you want to add this chart set to your dashboard?" }
]

export const warningLibrary = [
    { modalHeading: "Warning" },
    { modalContent: "You have selected libraries that already exist in your dashboard!" }
]

export const groupCreate = [
    { modalHeading: "Group Created" },
    { modalContent: "Group created successfully" }
];

export const updateCreate = [
    { modalHeading: "Group Updated" },
    { modalContent: "Group updated Successfully" }
];

export const dashboardCreateContent = [
    { modalHeading: "Congratulations!" },
    { modalContent: "You've successfully created a new dashboard. We're currently customizing your visualizations and analyses, which may take up to 60 minutes. Get ready to dive into your tailored dashboard and discover powerful data-driven insights!" }
];

export const dashboardCreateLibraryContent = [
    { modalHeading: "Congratulations!" },
    { modalContent: "You've successfully added this chart group to your dashboard. We're currently customizing your visualizations and analyses, which may take up to 60 minutes. Get ready to dive into your tailored dashboard and discover powerful data-driven insights!" }
];

export const dashboardCreateError = [
    { modalHeading: "Dashboard Creation error" },
    { modalContent: "Error while creating dashboard" }
];

export const dashboardEdit = [
    { modalHeading: "Dashboard Updated" },
    { modalContent: "Dashboard Updated successfully" }
];

export const dashboardAddedGroup = [
    { modalHeading: "Dashboard Added" },
    { modalContent: "Dashboards Added Successfully" }
];
export const dashboardErrorGroup = [
    { modalHeading: "Dashboard Added Error" },
    { modalContent: "Sorry, we encountered an issue while adding this group to the dashboards. Please try again" }
];

export const dashboardEditError = [
    { modalHeading: "Dashboard Updating Error" },
    { modalContent: "Error while Updating dashboard Update" }
];

export const URLExpired = [
    { modalHeading: "URL Expired" },
    { modalContent: "This link has expired or is no longer available. Please request a new link to continue." }
];

export const userNotFound = [
    { modalHeading: "User Not Found" },
    { modalContent: "Authentication failed. User not found." }
];

export const deleteAllDashboardContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "Are you sure you want to delete the Dashboard you selected?" }
];

export const noDeleteAnything = [
    { modalHeading: "Warning" },
    { modalContent: "please select atleast one dashboard." }
]

export const deleteShopContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "The selected shop already exist in the Shop group. Are you sure to delete the shop from the group?" }
]

export const deleteGroupShopContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "The selected shop are already part of the Shop Group. Deleting a shop will remove the group. Are you sure to delete the shop from the group?" }
]

export const deleteDashboardShopContent = [
    { modalHeading: "Confirm Delete" },
    { modalContent: "The selected shop are already part of the Shop Group. Deleting a shop will remove both the group and its dashboard. Are you sure to delete the shop from the group?" }
]

export const removeChartGroupShopContent = [
    { modalHeading: "Confirm Remove Chart" },
    { modalContent: "The flight shop you are attempting to modify is part of a shop group that requires charts to be enabled. Removing the charts from this shop will remove it from the group." },
    { modalContentTwo: "Are you sure you want to proceed with removing the charts?" }
]
export const removeChartGroupOnlyShop = [
    { modalHeading: "Confirm Remove Chart" },
    { modalContent: "The flight shop you are attempting to modify is part of a shop group that requires charts to be enabled. Removing the charts from this shop will remove it from the group and it will also delete the shop group." },
    { modalContentTwo: "Are you sure you want to proceed with removing the charts?" }
]

export const removeChartDashboardShop = [
    { modalHeading: "Confirm Remove Chart" },
    { modalContent: "The flight shop you are attempting to modify is part of a shop group that requires charts to be enabled. Removing the charts from this shop will remove it from the group and it will also delete the shop group and dashboard." },
    { modalContentTwo: "Are you sure you want to proceed with removing the charts?" }
]


export const bulkdeleteShopContent = (nameList) => [
    { modalHeading: "Confirm Delete" },
    { modalContent: `The selected ${nameList?.length > 1 ? "shops" : "shop"}, "${nameList?.map((res) => res?.shopName)?.join(', ')}" already exists in the Shop group. Are you sure you want to delete the ${nameList?.length > 1 ? "shops" : "shop"} from the group?` }
]

export const bulkdeleteGroupShopContent = (nameList) => [
    { modalHeading: "Confirm Delete" },
    { modalContent: `The selected ${nameList?.length > 1 ? "shops" : "shop"} "${nameList?.map((res) => res?.shopName)?.join(', ')}" already part of the Shop Group. Deleting a shops will remove the group. Are you sure to delete the shop from the group?` }
]

export const bulkdeleteDashboardShopContent = (nameList) => [
    { modalHeading: "Confirm Delete" },
    { modalContent: `The selected ${nameList?.length > 1 ? "shops" : "shop"} "${nameList?.map((res) => res?.shopName)?.join(', ')}" already part of the Shop Group. Deleting a shops will remove both the group and its dashboard. Are you sure to delete the shop from the group?` }
]

export const bulkDownloadWithoutqidGrp = (count, remaining) => [
    { modalHeading: !!remaining ? "Confirm Download" : "Warning" },
    { modalContent: "The extraction for these group shops is still in progress and the data for them is not yet available. Please try again later." }
]

export const bulkDownloadWithoutqidnewGrp = (withoutshop, withshop, totalshops) => [
    { modalHeading: "Confirm Download" },
    { modalContent: "The extraction for some of these group shops is still in progress and the data for them is not yet available. Do you want to continue?" }
]

export const bulkDownloadInfo = [
    { modalHeading: "Warning" },
    { modalContent: `Only up to 5 shops can be selected for download. Please adjust your selection.` }
]

export const onHoldContent = [
    { modalHeading: "Confirm Pause" },
    { modalContent: "Please confirm if you would like to pause the specific shop ?" }
]

export const bulkOnHoldContent = [
    { modalHeading: "Confirm Pause" },
    { modalContent: "Please confirm if you would like to pause the selected shops ?" }
]

export const cloneContent = [
    { modalHeading: "Confirm Duplicate" },
    { modalContent: "Do you want to duplicate the selected shop?" }
]

export const resumeContent = [
    { modalHeading: "Resume" },
    { modalContent: "Please confirm if you would like to Resume the specific market?" }
]

export const bulkResumeContent = [
    { modalHeading: "Resume" },
    { modalContent: "Please confirm if you would like to Resume the selected markets ?" }
]

export const groupInDashboards = (count) => [
    { modalHeading: "Confirm Delete" },
    { modalContent: `The selected ${count > 1 ? "groups" : "group"} already exist in the dashboard. Are you sure to delete the ${count > 1 ? "groups" : "group"} from the dashboard?` }
]

export const groupDashboardDelete = (count) => [
    { modalHeading: "Confirm Delete" },
    { modalContent: `The selected ${count > 1 ? "groups" : "group"} are already part of the dashboard. Deleting a ${count > 1 ? "groups" : "group"} will remove the dashboard. Are you sure to delete the ${count > 1 ? "groups" : "group"} from the dashboard?` }
]

export const groupShopDelete = (count) => [
    { modalHeading: "Confirm Delete" },
    { modalContent: `Please confirm if you would like to delete the specific market ${count > 1 ? "groups" : "group"}?` }
]

export const noShopSelected = [
    { modalHeading: "Warning" },
    { modalContent: "Please select at least two shops to create a group" }
]

export const noShopSelectedAction = [
    { modalHeading: "Warning" },
    { modalContent: "Please select atleast one shop." }
]

export const noVizShopSelected = [
    { modalHeading: "Warning" },
    { modalContent: "Please select atleast one non-visualized shop to create a Visualize Shop" }
]

export const vizShopedShopSelected = [
    { modalHeading: "Warning" },
    { modalContent: "please select atleast one visualized shop to remove a Visualize Shop" }
]

export const globalDownloadContent = [
    { modalHeading: "Global Download" },
    { modalContent: "The global download could not be completed because the data extraction is currently in progress. Please try again later." }
]

export const shopsDownloadContent = [
    { modalHeading: "Shops Download" },
    { modalContent: "The Shops download could not be completed because the data extraction is currently in progress. Please try again later." }
]

export const globalDownloadNotLinkContent = [
    { modalHeading: "Global Download" },
    { modalContent: "Global Download failed as data is not available for the selected date. Please select some another date" }
]

export const shopsDownloadNotLinkContent = [
    { modalHeading: "Shops Download" },
    { modalContent: "Shop download failed because no data is available for the selected shops. Please select different shops." }
]

export const globalDownloadSuccessContent = [
    { modalHeading: "Global Download" },
    { modalContent: "Global Download is successful and an S3 link with the data will be sent to your email address." }
]
export const globalDownloadRestrictedContent = [
    { modalHeading: "Global Download" },
    { modalContent: "Global download is restricted to intervals of 10 minutes" }
]
export const globalDownloadNoques = [
    { modalHeading: "Global Download" },
    { modalContent: "Global Download failed as data extraction is in progress. Please try after sometime." }
]
export const selectedShopsDownloadSuccessContent = [
    { modalHeading: "Shops Download" },
    { modalContent: "Shops Download is successful and an S3 link with the data will be sent to your email address." }
]
export const nonVisualiseShop = (len) => ([
    { modalHeading: "Warning" },
    { modalContent: "It looks like one or more of the flight shops you selected do not have charts enabled. To proceed with grouping these shops, charts will need to be enabled for all selected flight shops." },
    { modalContentTwo: "Would you like to continue and enable charts for all selected shops?" }
])

export const alreadyVisualiseShop = (len) => ([
    { modalHeading: "Warning" },
    { modalContent: `From the selected ${len} shops are already visualized.` }
])

export const alreadyMaxVisualiseShopCreatred = (count, limit) => {
    return ([
        { modalHeading: "Warning" },
        { modalContent: limit - count > 0 ? `You are attempting to make more than the ${limit} visualize shops limit set to your account. You have already created ${count} visualize shops, so you can only add ${limit - count} more visualize shop` : `You have reached the maximum limit of visualized shops. The maximum limit of shops is set to ${limit}.` }
    ])
}

export const alreadyMaxVisualiseShopCreatredResume = (count, limit, shops) => {
    return ([
        { modalHeading: "Warning" },
        { modalContent: limit - count > 0 ? `You are trying to resume ${shops} shops, but you can only resume ${limit - count}, as the maximum visualized shop limit is ${limit}.` : `You have already reached the limit of ${limit} visualized shops. To resume, you need to convert ${shops} active shops to non-visualize.` }
    ])
}

export const resumeExtraVisShop = (limit, shopNames) => {
    return ([
        { modalHeading: "Warning" },
        { modalContent: `You have already reached the limit of ${limit} visualized shops. To resume, you need to convert ${shopNames?.length} active shops to non-visualize.` }
    ])
}

export const alreadyReachedMax = (limit) => ([
    { modalHeading: "Warning" },
    { modalContent: `You have reached the maximum limit of visualized shops. The maximum limit of shops is set to ${limit}.` }
])

export const visualisdeShop = (len) => ([
    { modalHeading: "Warning" },
    { modalContent: `From the selected ${len} shops are already non - visualized.` }
])

export const visualisdeShopContinue = (len) => ([
    { modalHeading: "Warning" },
    { modalContent: `From the selected ${len} shops are already non - visualized. Are you sure you want to proceed?` }
]);

export const createInitialSortState = (data) => {
    if (!data || !data[0]) return {};
    return Object?.keys(data[0])?.reduce((acc, header) => {
        acc[header] = null;
        return acc;
    }, {});
};

// Update sorting of table
export const updateSortState = (prevState, header) => {
    return Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === header ? getSortOrder(prevState[header]) : null;
        return acc;
    }, {});
};

// Define Sorting order
export const getSortOrder = (currentSortOrder) => {
    return currentSortOrder === 'asc' ? 'desc' : 'asc';
};

// Sorting for datas in table
export const compareValues = (a, b, sortOrder, currentHeader) => {
    const valueA = currentHeader === "shopname" ? String(a?.props?.children)
        : currentHeader === "Name" || currentHeader === "Shop Name" ? String(a?.props?.children?.props ? a?.props?.children?.props?.children?.[1]?.props?.children?.props?.children?.[1]?.props?.children?.props?.children : a?.props?.children)
            : currentHeader === "brands" ? String(a?.props?.children.props?.children.props?.children)
                : currentHeader === "otas" ? String(a?.props?.children.props?.children.props?.children)
                    : currentHeader === "Sources" ? String(a?.props?.children.props?.children?.props?.children?.[0])
                        : currentHeader === "horizon" ? String(a?.props?.children.props?.children[0].props?.children || a?.props?.children.props?.children[1].props?.children)
                            : currentHeader === "source" ? String(a?.props?.children)
                                : currentHeader === "call counts" ? String(a?.props?.children)
                                    : currentHeader === "extraction end time" ? String(a?.props?.children)
                                        : currentHeader === "extraction start time" ? String(a?.props?.children)
                                            : currentHeader === "outcome" ? String(a?.props?.children)
                                                : currentHeader === "errors" ? String(a?.props?.children)
                                                    : currentHeader === "cost" ? String(a?.props?.children)
                                                        : currentHeader === "Group Name" ? String(a?.props?.children)
                                                            : currentHeader === "groupName" ? String(a?.props?.children.props?.children)
                                                                : currentHeader === "Dashboard Name" ? String(a?.props?.children)
                                                                    : currentHeader === "Calls count" ? Number(parseFloat(a.replace(/,/g, '')))
                                                                        : String(a);
    const valueB = currentHeader === "shopname" ? String(b?.props?.children)
        : currentHeader === "Name" || currentHeader === "Shop Name" ? String(b?.props?.children?.props ? b?.props?.children?.props?.children?.[1]?.props?.children?.props?.children?.[1]?.props?.children?.props?.children : b?.props?.children)
            : currentHeader === "brands" ? String(b?.props?.children.props?.children.props?.children)
                : currentHeader === "otas" ? String(b?.props?.children.props?.children.props?.children)
                    : currentHeader === "Sources" ? String(b?.props?.children.props?.children?.props?.children?.[0])
                        : currentHeader === "horizon" ? String(b?.props?.children.props?.children[0].props?.children || b?.props?.children.props?.children[1].props?.children)
                            : currentHeader === "source" ? String(b?.props?.children)
                                : currentHeader === "call counts" ? String(b?.props?.children)
                                    : currentHeader === "extraction end time" ? String(b?.props?.children)
                                        : currentHeader === "extraction start time" ? String(b?.props?.children)
                                            : currentHeader === "outcome" ? String(b?.props?.children)
                                                : currentHeader === "errors" ? String(b?.props?.children)
                                                    : currentHeader === "cost" ? String(b?.props?.children)
                                                        : currentHeader === "Group Name" ? String(b?.props?.children)
                                                            : currentHeader === "groupName" ? String(b?.props?.children.props?.children)
                                                                : currentHeader === "Dashboard Name" ? String(b?.props?.children)
                                                                    : currentHeader === "Calls count" ? Number(parseFloat(b.replace(/,/g, '')))
                                                                        : String(b);
    if (sortOrder === 'asc') {
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0;
    } else {
        if (valueA > valueB) return -1;
        if (valueA < valueB) return 1;
        return 0;
    }
};

export const TOO_LARGE_MESSAGE = "The request is too large. Please try a smaller file or fewer items.";

// Reads the JSON body of an API response (or error response). The API sends plain JSON over TLS
// to this client; a bare string body is surfaced as { message }.
export const responseData = (response) => {
  if (!response) return null;
  // 413 usually comes from the proxy or body parser as HTML/plain text, not the API's JSON
  if (response.status === 413) return { message: TOO_LARGE_MESSAGE };
  if (!response.data) return null;
  if (typeof response.data === "object") return response.data;
  try {
    return JSON.parse(response.data);
  } catch (e) {
    // Proxy error pages (502/504 etc.) are HTML; never show their markup to the user
    if (/^\s*</.test(response.data)) return null;
    return { message: response.data };
  }
};

// Meta/OTA simultaneous-selection restriction disabled for now (was added alongside Deep Search)
// // Source display names aren't consistently just "Google" — e.g. the OTA entry may be named
// // "Google OTA" while the Metasource entry is named "Google". Normalize the same way
// // StepOne.jsx's conflictingPairs logic does before comparing.
// const normalizeSourceName = (name) => (name || "").toLowerCase().replace(/ota|metasource|meta/gi, "").trim();
//
// // codes: the full source list from Redux (state.source.sourceDatas.source)
// export const getGoogleSourceCodes = (codes) => ({
//   googleOtaCode: codes?.find((s) => s?.sourceType === "OTA" && normalizeSourceName(s?.source) === "google")?.code,
//   googleMetaCode: codes?.find((s) => s?.sourceType === "Metasource" && normalizeSourceName(s?.source) === "google")?.code,
// });
//
// // shops: array of shop objects with a `.sources` array of currently selected source codes.
// // Some endpoints (e.g. mymarketpage) return `.sources` as display names instead of codes but
// // also provide a `.sourceCodes` numeric array alongside it — prefer that when present.
// export const isGoogleOtaAlreadySelected = (shops, googleOtaCode) =>
//   !!googleOtaCode && !!shops?.some((shop) => (shop?.sourceCodes || shop?.sources)?.includes(googleOtaCode));
//
// // Content for the shared "Chart Requirement" rate-parity confirmation modal, swapped
// // based on whether Google OTA is already selected and will be removed in favor of Google Meta.
// export const googleMetaRequiredContent = (otaGoogleSelected) => otaGoogleSelected
//   ? [
//     { header: "Chart Requirement" },
//     { modalContent: "Some of your shops currently have Google selected under OTA. Meta Google is required for this Chart Set, so Google will be removed from OTA and added under Meta for the applicable shops." },
//     { modalContentTwo: "Would you like to continue?" },
//   ]
//   : [
//     { header: "Chart Requirement" },
//     { modalContent: "It looks like some of your shops don't have the Google data required for the Chart Set. We will include Google data for all shops to add this Chart Set." },
//     { modalContentTwo: "Would you like to continue?" },
//   ];